<script setup lang="ts">
import { type DateValue, parseDate } from '@internationalized/date'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import DateInput from '../date-input/DateInput.vue'
import { ARadioInput } from '../generics'
import { ATabs } from '../tabs'
import { relativeValues, type TableFilterRelativeValue, type TableFilterValueOptions, useGetFilterValueLabel } from '.'

interface TabItem {
  label: string
  value: 'relative' | 'absolute'
}

const valueIsRelative = computed((): boolean => relativeValues.includes(filterModel.value?.values[0] as TableFilterRelativeValue))
const filterModel = defineModel<TableFilterValueOptions>({ default: { operator: 'equal', values: [] }, required: true })
const tabModel = ref<'relative' | 'absolute'>(valueIsRelative.value ? 'relative' : 'absolute')
const getFilterLabelValue = useGetFilterValueLabel()

function setAbsoluteDate(date: DateValue | undefined) {
  if (!date) {
    filterModel.value.values = []
    return
  }

  filterModel.value.values = [date.toString()]
}

const absoluteDate = computed((): DateValue | undefined => {
  const value = filterModel.value?.values?.[0]
  if (valueIsRelative.value) {
    return
  }
  if (!value) {
    return
  }
  return parseDate(value)
})
const { t } = useI18n({
  messages: {
    en: {
      absolute: 'Absolute',
      relative: 'Relative',
    },
    nl: {
      absolute: 'Absoluut',
      relative: 'Relatief',
    },
  },
})

const tabItems: TabItem[] = [
  { title: t('absolute'), value: 'absolute' },
  { title: t('relative'), value: 'relative' },
]
</script>

<template>
  <div class="atabix-table-filter-section space-y-3">
    <ATabs v-model="tabModel" :items="tabItems" />

    <DateInput v-if="tabModel === 'absolute'" :model-value="absoluteDate" @update:model-value="setAbsoluteDate($event)" />
    <ARadioInput
      v-if="tabModel === 'relative'"
      :items="
        relativeValues.map((value) => ({
          label: getFilterLabelValue({ type: 'date' }, value),
          value: value,
        }))
      "
      :model-value="filterModel.values[0]"
      @update:model-value="filterModel.values = [$event]"
    />
  </div>
</template>
